import React from 'react';
import {css} from 'emotion';
const Button = (props) =>{
  return(
    <div onClick={props.onPress}
        style={{...props.style}}
        className={css`
          cursor:pointer;
          display:inline-block;
          background-color:${props.color};
          color:white;
          padding-left:10px;
          padding-right:10px;
          padding-top:5px;
          padding-bottom:5px;
          margin-top:20px;
          border-radius:10px;
          &:hover{
            background-color:${props.hoverColor}
          }
          `}>
          {props.text}
        </div>
  )
}

export default Button;
